import React from 'react'
import PlaceHolderImage from '../blog/place-holder-image'

import 'swiper/scss'

const BlogCard = ({ slide, index }) => {
  const { title, featuredImage, author, modified, uri } = slide
  const formmattedDate = new Date(modified).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

  return (
    <swiper-slide>
      <div className='card-wrapper'>
        <a href={uri ?? ''}>
          <div className='card-image'>
            {featuredImage ?
                <img src={featuredImage?.node?.sourceUrl ?? ''} alt={featuredImage?.node?.altText ?? ''} />
              : <PlaceHolderImage index={index} />
              }
          </div>
          <div className='card-content'>
            <div className='card-metadata'>
              <span className='card-author'>{author?.node?.name ?? ''}</span>
              <span className="metadata-separator">•</span>
              <span className='card-date'>{formmattedDate}</span>
            </div>
            <h4 className='card-heading'>{title}</h4>
          </div>
        </a>
      </div>
    </swiper-slide>
  )
}

export default BlogCard
